module.exports = __webpack_public_path__ + "img/Technology_PC_CN@3x.7b577767.png";